import { EFieldName } from '../../../../../../types/field';

export type TTextFieldType =
  | EFieldName.Balconies
  | EFieldName.BuildYear
  | EFieldName.CategoryName
  | EFieldName.CeilingHeight
  | EFieldName.Lifts
  | EFieldName.Mortgage
  | EFieldName.RepairType
  | EFieldName.HouseClass
  | EFieldName.StartDate
  | EFieldName.MaterialType
  | EFieldName.WC;

export const TYPE_FIELDS_MAP: Record<TTextFieldType, string[]> = {
  [EFieldName.Balconies]: ['balconies'],
  [EFieldName.BuildYear]: ['buildYear'],
  [EFieldName.CategoryName]: ['categoryName'],
  [EFieldName.CeilingHeight]: ['ceilingHeight'],
  [EFieldName.Lifts]: ['lifts'],
  [EFieldName.Mortgage]: ['mortgage'],
  [EFieldName.RepairType]: ['repairType'],
  [EFieldName.HouseClass]: ['newbuilding', 'className'],
  [EFieldName.StartDate]: ['newbuildingHouse', 'startDate'],
  [EFieldName.MaterialType]: ['newbuildingHouse', 'materialType'],
  [EFieldName.WC]: ['wc'],
};
